export default __webpack_public_path__ + "213f43de7ce4507078b4fd3ffa4ea680.png";